module.exports = __webpack_public_path__ + "static/img/login-bg-2.b62db786.png";